import type { ReactNode } from 'react';

import { CommandPaletteProvider } from '@/components/search/CommandPalette';
import { AdminSidebar } from '@/components/shell/AdminSidebar';
import { AttentionProvider } from '@/components/shell/AttentionProvider';
import { useAdminAccess } from '@/hooks/useAdminAccess';

export function AdminShell({ children }: { children: ReactNode }) {
  const { isPlatformAdmin } = useAdminAccess();
  return (
    <AttentionProvider enabled={isPlatformAdmin}>
      <CommandPaletteProvider>
        <div className="app-hub-shell h-screen w-full bg-background text-foreground">
          <AdminSidebar />
          <main className="app-hub-main min-h-0 min-w-0 flex-1 overflow-auto">
            <div className="h-full min-h-0 w-full">{children}</div>
          </main>
        </div>
      </CommandPaletteProvider>
    </AttentionProvider>
  );
}
